export default "__VITE_ASSET__RkkoSQ9V__"